import { render, staticRenderFns } from "./AdminSpecialistBookingsMenu.vue?vue&type=template&id=e6cfe3dc"
import script from "./AdminSpecialistBookingsMenu.vue?vue&type=script&lang=js"
export * from "./AdminSpecialistBookingsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports